module.exports = __webpack_public_path__ + "img/horizontal_4_2_7005.ba7c2f3e.png";